/**
 * Weak-password nudge handoff between the login flow and the authenticated shell.
 *
 * `login()` (utils/auth.ts) ends in a hard navigation (`window.location.href`), which
 * resets all in-memory Jotai state — so setting `passwordChangePromptAtom` from the
 * login form never survives to the page that renders the prompt. Instead the login flow
 * queues the prompt here (sessionStorage is per-tab and survives the navigation) and
 * ScNavbar consumes it on mount, opening the prompt via the atom.
 */
const KEY = 'sc:passwordChangePrompt';

export type PasswordChangePrompt = { title: string; message: string };

export const queuePasswordChangePrompt = (title: string, message: string) => {
  try {
    window.sessionStorage.setItem(KEY, JSON.stringify({ title, message }));
  } catch {
    // storage unavailable — losing the nudge is acceptable
  }
};

export const consumePasswordChangePrompt = (): PasswordChangePrompt | null => {
  try {
    const raw = window.sessionStorage.getItem(KEY);
    if (!raw) return null;
    window.sessionStorage.removeItem(KEY);
    return JSON.parse(raw);
  } catch {
    return null;
  }
};
